"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterSelect = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const R = __importStar(require("ramda"));
const react_1 = __importDefault(require("react"));
const Option_1 = require("./Option");
const Menu_1 = require("../Menu");
const Menu_2 = require("./Menu");
const util_1 = require("./util");
const useFilterState_1 = require("./useFilterState");
const DefaultFilterSelectInput_1 = require("./DefaultFilterSelectInput");
function FilterSelect({ Option = Option_1.DefaultOption, isMatch = util_1.defaultIsMatch, isSelected = util_1.defaultIsSelected, Input = DefaultFilterSelectInput_1.DefaultFilterSelectInput, onChange, options, value, }) {
    const filter = (0, useFilterState_1.useFilterState)();
    // Determine the subset of options that match the search.
    const found = react_1.default.useMemo(() => {
        return R.filter((option) => {
            return isMatch(filter.search, option);
        }, options);
    }, [filter.search, options, isMatch]);
    // Determine the option that is selected.
    const selected = react_1.default.useMemo(() => {
        return R.find((option) => {
            return isSelected(value, option);
        }, options);
    }, [value, options, isSelected]);
    // Fired when an option is clicked.
    const onClickOption = react_1.default.useCallback(({ option, close, }) => {
        onChange(option.value);
        filter.onInputChange(option.label);
        close();
    }, [onChange, filter.onInputChange]);
    react_1.default.useEffect(() => {
        if (!R.isNil(selected) && !filter.hasInput) {
            filter.onInputChange(selected.label);
        }
    }, [selected, filter.input]);
    return ((0, jsx_runtime_1.jsx)(Menu_1.Menu.Flyout, Object.assign({ content: ({ close }) => ((0, jsx_runtime_1.jsx)(Menu_2.SelectMenu, { Option: Option, onClick: (option) => onClickOption({ option, close }), isSelected: isSelected, options: found, value: value })) }, { children: (props) => {
            return ((0, jsx_runtime_1.jsx)(Input, Object.assign({}, props, { filter: filter })));
        } })));
}
exports.FilterSelect = FilterSelect;
